// {{WORKTREE_ROOT}}/picosponsorconsole/packages/design/src/components/LoadingDots.tsx
// PLAN2 WP09 — C-125: three round dots in the text colour, pulsing 0/160/320 ms apart (--motion-pulse); static under
// reduced motion. Always aria-hidden: the control showing them carries aria-busy. Round, like the pills.
import { cx } from "../cx.js";
import { DESIGN_TESTIDS as T } from "../testids.js";

const DOT: Record<5 | 6, string> = { 5: "w-1.25 h-1.25", 6: "w-1.5 h-1.5" };

export function LoadingDots({ size = 6, className, "data-testid": testId }: { size?: 5 | 6; className?: string; "data-testid"?: string }) {
  return (
    <span aria-hidden="true" data-testid={testId ?? T.loadingDots.root} className={cx("inline-flex items-center gap-1", className)}>
      <span className={cx("block rounded-round bg-current animate-pulse", DOT[size])} />
      <span className={cx("block rounded-round bg-current animate-pulse [animation-delay:160ms]", DOT[size])} />
      <span className={cx("block rounded-round bg-current animate-pulse [animation-delay:320ms]", DOT[size])} />
    </span>
  );
}
